import request from '@/utils/request'

//手机号登录
export async function getApply(params) {
    return request({ url: '/api/user/apply', method: 'post', data: params })
}

//手机号登录
export async function getLogin(params) {
    return request({ url: '/api/user/mobilelogin', method: 'post', data: params })
}
//手机号登录
export async function getCode(params) {
    return request({ url: '/api/message/captcha', method: 'post', data: params })
}
//是否绑定微信
export async function hasWechat(params) {
    return request({ url: '/api/user/has_wechat', method: 'post', data: params })
}

//列表
export async function getList(params) {
    return request({ url: '/api/user/user_list', method: 'post', data: params })
}
//我的产业链列表
export async function getMyIndustryChain(params) {
    return request({ url: '/api/user/myIndustryChain', method: 'post', data: params })
}
//我的产业链标签
export async function getTags(params) {
    return request({ url: '/api/user/getTags', method: 'post', data: params })
}
//登录用户信息
export async function getLoginUser() {
    return request({ url: '/api/user/getLoginUser', method: 'post', data: {} })
}
//详情
export async function getDetail(params) {
    return request({ url: '/api/user/user_info', method: 'post', data: params })
}
//关注列表
export async function getFollowList(params) {
    return request({ url: '/api/user/follow_users', method: 'post', data: params })
}
//关注/取消关注
export async function addFollow(params) {
    return request({ url: '/api/user/follow', method: 'post', data: params })
}
//联系指定会员
export async function addContact(params) {
    return request({ url: '/api/user/contact', method: 'post', data: params })
}

//相互关注列表
export async function getFollowListMe(params) {
    return request({ url: '/api/user/follow_me', method: 'post', data: params })
}

//消息通知
export async function getNotice(params) {
    return request({ url: '/api/user/notice', method: 'post', data: params, hideloading: true })
}

/**根据搜索关键字查询公司列表 */
export async function getCompanyLists(params) {
    return request({ url: '/api/index/get_ompany', method: 'get', params, hideloading: true })
}
/**根据公司名称查询公司信息，
 * area_code 地区对应的code
 * province 省
 * city 市
 */
export async function getCompanyInfo(params) {
    return request({ url: '/api/index/get_ompany_detail', method: 'get', params, hideloading: true })
}

/************************咨询模块**********************/
/**
 * 活动banner
 */
export async function getCounsellingBanner(params) {
    return request({ url: '/api/counselling/banner', method: 'get', params, hideloading: true })
}
/**
 * 咨询类目类型
 */
export async function getCounsellingType(params) {
    return request({ url: '/api/counselling/counselling_type', method: 'get', params, hideloading: true })
}
/**
 * 咨询列表
 */
export async function getcounsellingList(params) {
    return request({ url: '/api/counselling/counselling_list', method: 'post', data:params })
}
/**
 * 咨询详情
 */
export async function getcounsellingDetail(params) {
    return request({ url: '/api/counselling/counselling_info', method: 'post', data:params })
}

/************************咨询模块**********************/

/************************活动模块开始**********************/
/**
 * 活动banner
 */
export async function getActivityBanner(params) {
    return request({ url: '/api/activity/banner', method: 'get', params, hideloading: true })
}
/**
 * 活动类目类型
 */
export async function getActivityType(params) {
    return request({ url: '/api/activity/activity_type', method: 'get', params, hideloading: true })
}
/**
 * 咨询列表
 */
export async function getActivityList(params) {
    return request({ url: '/api/activity/counselling_list', method: 'post', data: params })
}

/************************咨询模块结束**********************/
/************************H5模块开始**********************/
export async function getH5Finance(params) {
    return request({ url: '/api/h5/finance', method: 'post', data: params })
}
export async function getFinanceCaptcha(params) {
    return request({ url: '/api/message/financeCaptcha', method: 'post', data: params })
}
export async function getH5CultivationSurveyForm(params) {
    return request({ url: '/api/h5/cultivationSurveyForm', method: 'post', data: params })
}
export async function getCultivationSurveyCaptcha(params) {
    return request({ url: '/api/message/cultivationSurveyCaptcha', method: 'post', data: params })
}
export async function getRegistrationLogin(params) {
    return request({ url: '/api/h5registration/login', method: 'post', data: params })
}
export async function getRegistrationCaptcha(params) {
    return request({ url: '/api/message/registrationCaptcha', method: 'post', data: params })
}
export async function getRegistrationInformation(params) {
    return request({ url: '/api/h5registration/information', method: 'post', data: params })
}
export async function editRegistrationInformation(params) {
    return request({ url: '/api/h5registration/editInformation', method: 'post', data: params })
}
export async function getRegistrationMemberList(params) {
    return request({ url: '/api/h5registration/memberList', method: 'post', data: params })
}
export async function registrationIntentionSelect(params) {
    return request({ url: '/api/h5registration/intentionSelect', method: 'post', data: params })
}
export async function getH5CapitalBusinessForm(params) {
    return request({ url: '/api/h5/capitalBusinessForm', method: 'post', data: params })
}
export async function getCapitalBusinessCaptcha(params) {
    return request({url: '/api/message/capitalBusinessCaptcha', method: 'post', data: params})
}
export async function getH5Trisome(params) {
    return request({ url: '/api/h5/trisome', method: 'post', data: params })
}
export async function getTrisomeCaptcha(params) {
    return request({ url: '/api/message/trisomeCaptcha', method: 'post', data: params })
}
export async function h5Guestbook(params) {
    return request({ url: '/api/h5/guestbook', method: 'post', data: params })
}
// 产业通企业列表
export async function getIndustryIntegrationCompanyList(params) {
    return request({ url: '/api/industryIntegration/companyList', method: 'post', data: params })
}
// 产业通行业列表
export async function getIndustryIntegrationCategoryList(params) {
    return request({ url: '/api/industryIntegration/categoryList', method: 'post', data: params })
}
// 产业通荣誉列表
export async function getIndustryIntegrationHonorList(params) {
    return request({ url: '/api/industryIntegration/honorList', method: 'post', data: params })
}
export async function getIndustryIntegrationCaptcha(params) {
    return request({ url: '/api/message/industryIntegrationCaptcha', method: 'post', data: params })
}
export async function industryIntegrationReport(params) {
    return request({ url: '/api/industryIntegration/report', method: 'post', data: params })
}
/************************H5模块結束**********************/
/**
 * 配置
 */
export async function geSourceConfig(params) {
    return request({ url: '/api/index/source_config', method: 'post', data: params })
}

/**
 * 配置
 */
export async function getVipDuration(params) {
    return request({ url: '/api/user/vip_duration', method: 'get', params })
}

//根据动态验证码获取短信验证码
export async function getCodeFormCaptcha(params) {
    return request({ url: '/api/message/apply', method: 'get', params })
}
/**
 * JSSDK
 */
export async function getJsSdk(params) {
    return request({ url: '/api/wx/jsSdk', method: 'post', data: params })
}
